import { Paths } from '../constants/Paths';
export function buildInvoiceDetailsUrl(invoice) {
  const params = new URLSearchParams();
  params.set('invoiceId', String(invoice.objectId));
  params.set('invoiceNumber', invoice.invoiceNumber);
  if (invoice.invoiceLink) {
    params.set('url', invoice.invoiceLink);
  }
  if (invoice.downloadLink) {
    params.set('downloadUrl', invoice.downloadLink);
  }
  return `${Paths.INVOICE_DETAILS}?${params.toString()}`;
}